function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoNFTCard = require('./../../../../../lib/saito/ui/saito-nft/saito-nft-card');
var PublishNFTTemplate = require('./publish-nft.template');
var _require = require('./overlay.shell'),
  applyPublishOverlayShell = _require.applyPublishOverlayShell;
var _require2 = require('../script_build'),
  lockingView = _require2.lockingView;
function escapeHtml(text) {
  return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function parseSaitoAmount(raw) {
  var allowZero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var text = String(raw || '').trim();
  if (!text && allowZero) {
    return '0';
  }
  if (!text) {
    return null;
  }
  var num = Number(text);
  if (!Number.isFinite(num) || num < 0) {
    return null;
  }
  if (!allowZero && num <= 0) {
    return null;
  }
  return text;
}
function parseNftAmount(raw) {
  var text = String(raw || '').trim();
  if (!text) {
    return null;
  }
  var amount = parseInt(text, 10);
  if (!Number.isInteger(amount) || amount <= 0) {
    return null;
  }
  return amount;
}
var PublishNFTFlow = /*#__PURE__*/function () {
  function PublishNFTFlow(app, mod, mainUi, publishFlow) {
    var _this = this;
    _classCallCheck(this, PublishNFTFlow);
    this.app = app;
    this.mod = mod;
    this.mainUi = mainUi;
    this.publishFlow = publishFlow;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay["class"] = 'saito-overlay rs-publish-overlay-shell';
    this.overlay.clickBackdropToClose = true;
    this.overlay.nonBlocking = false;
    this.step = null;
    this.p2shAddress = '';
    this.p2shHash = '';
    this.cardList = [];
    this.selectedCard = null;
    this.blockedRoot = null;
    this.onEscapeKey = function (event) {
      if (event.key === 'Escape' && _this.step) {
        _this.hide();
      }
    };
  }
  return _createClass(PublishNFTFlow, [{
    key: "openSend",
    value: function () {
      var _openSend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var locking, hash, address, defaultFee, fee;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              locking = lockingView(this.mod.getScript());
              hash = this.app.core.scripting.hash(locking);
              address = this.app.core.scripting.address(locking);
              if (!(!hash || !address)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.p2shAddress = address;
              this.p2shHash = hash;
              this.selectedCard = null;
              this.cardList = [];
              defaultFee = this.app.wallet.convertNolanToSaito(this.app.wallet.default_fee || BigInt(0));
              fee = defaultFee && defaultFee !== '0.00' ? defaultFee : '0.001';
              this.step = 'send';
              this.show(PublishNFTTemplate.sendOverlay({
                p2shAddress: escapeHtml(address),
                fee: fee
              }));
              _context.n = 2;
              return this.renderNftList();
            case 2:
              this.bindSendEvents();
              this.syncPublishButtonState();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function openSend() {
        return _openSend.apply(this, arguments);
      }
      return openSend;
    }()
  }, {
    key: "show",
    value: function show(html) {
      var _this2 = this;
      document.body.classList.add('rs-publish-modal-open');
      this.blockedRoot = document.querySelector('main.rustscript');
      if (this.blockedRoot) {
        this.blockedRoot.inert = true;
      }
      document.addEventListener('keydown', this.onEscapeKey);
      this.overlay.show(html, function () {
        _this2.onOverlayClosed();
      });
      this.applyOverlayLayout();
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.step) {
        this.overlay.close();
      }
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      document.body.classList.remove('rs-publish-modal-open');
      document.removeEventListener('keydown', this.onEscapeKey);
      if (this.blockedRoot) {
        this.blockedRoot.inert = false;
        this.blockedRoot = null;
      }
      this.step = null;
      this.selectedCard = null;
      this.cardList = [];
    }
  }, {
    key: "applyOverlayLayout",
    value: function applyOverlayLayout() {
      applyPublishOverlayShell(this.overlay);
    }
  }, {
    key: "updateCardList",
    value: function () {
      var _updateCardList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        var nftList, _iterator, _step, _loop, j, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.n = 1;
              return this.app.wallet.updateNFTList();
            case 1:
              nftList = this.app.options.wallet.nfts || [];
              this.cardList.forEach(function (card) {
                card.delete_me = true;
              });
              _iterator = _createForOfIteratorHelper(nftList);
              _context4.p = 2;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var rec, alreadyRendered, _loop2, i, card;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      rec = _step.value;
                      alreadyRendered = false;
                      _loop2 = /*#__PURE__*/_regenerator().m(function _loop2(i) {
                        return _regenerator().w(function (_context2) {
                          while (1) switch (_context2.n) {
                            case 0:
                              if (!(rec.id === _this3.cardList[i].nft.id)) {
                                _context2.n = 1;
                                break;
                              }
                              _this3.cardList[i].callback = function (nft) {
                                return _this3.onNftSelected(_this3.cardList[i]);
                              };
                              delete _this3.cardList[i].delete_me;
                              alreadyRendered = true;
                              return _context2.a(2, 1);
                            case 1:
                              return _context2.a(2);
                          }
                        }, _loop2);
                      });
                      i = 0;
                    case 1:
                      if (!(i < _this3.cardList.length)) {
                        _context3.n = 4;
                        break;
                      }
                      return _context3.d(_regeneratorValues(_loop2(i)), 2);
                    case 2:
                      if (!_context3.v) {
                        _context3.n = 3;
                        break;
                      }
                      return _context3.a(3, 4);
                    case 3:
                      i++;
                      _context3.n = 1;
                      break;
                    case 4:
                      if (!alreadyRendered) {
                        card = new SaitoNFTCard(_this3.app, _this3.mod, '.rs-publish-nft-list', null, rec, function (nft) {
                          return _this3.onNftSelected(card);
                        });
                        _this3.cardList.push(card);
                      }
                    case 5:
                      return _context3.a(2);
                  }
                }, _loop);
              });
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context4.n = 5;
                break;
              }
              return _context4.d(_regeneratorValues(_loop()), 4);
            case 4:
              _context4.n = 3;
              break;
            case 5:
              _context4.n = 7;
              break;
            case 6:
              _context4.p = 6;
              _t = _context4.v;
              _iterator.e(_t);
            case 7:
              _context4.p = 7;
              _iterator.f();
              return _context4.f(7);
            case 8:
              for (j = this.cardList.length - 1; j >= 0; j--) {
                if (this.cardList[j].delete_me) {
                  this.cardList.splice(j, 1);
                }
              }
            case 9:
              return _context4.a(2);
          }
        }, _callee2, this, [[2, 6, 7, 8]]);
      }));
      function updateCardList() {
        return _updateCardList.apply(this, arguments);
      }
      return updateCardList;
    }()
  }, {
    key: "renderNftList",
    value: function () {
      var _renderNftList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this4 = this;
        var container, _iterator2, _step2, _loop3, _t2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              container = document.querySelector('.rs-publish-nft-list');
              if (container) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              _context6.n = 2;
              return this.updateCardList();
            case 2:
              if (this.cardList.length) {
                _context6.n = 3;
                break;
              }
              container.innerHTML = "\n        <div class=\"rs-publish-nft-empty instructions\">\n          You do not have any NFTs in your wallet.\n        </div>";
              return _context6.a(2);
            case 3:
              container.innerHTML = '';
              _iterator2 = _createForOfIteratorHelper(this.cardList);
              _context6.p = 4;
              _loop3 = /*#__PURE__*/_regenerator().m(function _loop3() {
                var card;
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      card = _step2.value;
                      card.callback = function (nft) {
                        return _this4.onNftSelected(card);
                      };
                      _context5.n = 1;
                      return card.render();
                    case 1:
                      return _context5.a(2);
                  }
                }, _loop3);
              });
              _iterator2.s();
            case 5:
              if ((_step2 = _iterator2.n()).done) {
                _context6.n = 7;
                break;
              }
              return _context6.d(_regeneratorValues(_loop3()), 6);
            case 6:
              _context6.n = 5;
              break;
            case 7:
              _context6.n = 9;
              break;
            case 8:
              _context6.p = 8;
              _t2 = _context6.v;
              _iterator2.e(_t2);
            case 9:
              _context6.p = 9;
              _iterator2.f();
              return _context6.f(9);
            case 10:
              return _context6.a(2);
          }
        }, _callee3, this, [[4, 8, 9, 10]]);
      }));
      function renderNftList() {
        return _renderNftList.apply(this, arguments);
      }
      return renderNftList;
    }()
  }, {
    key: "onNftSelected",
    value: function onNftSelected(card) {
      this.selectedCard = card;
      document.querySelectorAll('.rs-publish-nft-list .saito-nft-card').forEach(function (el) {
        el.classList.remove('is-selected');
      });
      var cardEl = document.querySelector(card.my_qs);
      cardEl === null || cardEl === void 0 || cardEl.classList.add('is-selected');
      this.updateSelectedSummary();
      this.syncPublishButtonState();
    }
  }, {
    key: "updateSelectedSummary",
    value: function updateSelectedSummary() {
      var _this$selectedCard;
      var slot = document.querySelector('.rs-publish-nft-selected-slot');
      var amountInput = document.querySelector('.rs-publish-nft-amount');
      var maxBtn = document.querySelector('.rs-publish-nft-max-btn');
      if (!slot) {
        return;
      }
      if (!((_this$selectedCard = this.selectedCard) !== null && _this$selectedCard !== void 0 && _this$selectedCard.nft)) {
        slot.innerHTML = PublishNFTTemplate.selectedNftSummaryHtml({});
        if (amountInput) {
          amountInput.value = '1';
          amountInput.disabled = true;
        }
        maxBtn === null || maxBtn === void 0 || maxBtn.setAttribute('disabled', 'disabled');
        return;
      }
      var nft = this.selectedCard.nft;
      var total = nft.getTotalAmount ? nft.getTotalAmount() : 0;
      var imageStyle = '';
      if (nft.image) {
        imageStyle = "background-image: url(\"".concat(escapeHtml(nft.image), "\");");
      }
      slot.innerHTML = PublishNFTTemplate.selectedNftSummaryHtml({
        title: escapeHtml(nft.title || 'Untitled NFT'),
        type: escapeHtml(nft.returnType ? nft.returnType() : ''),
        units: escapeHtml(String(total)),
        imageStyle: imageStyle
      });
      if (amountInput) {
        amountInput.disabled = false;
        amountInput.value = '1';
      }
      maxBtn === null || maxBtn === void 0 || maxBtn.removeAttribute('disabled');
    }
  }, {
    key: "syncPublishButtonState",
    value: function syncPublishButtonState() {
      var _this$selectedCard2;
      var btn = document.querySelector('[data-action="publish-nft-broadcast"]');
      if (!btn) {
        return;
      }
      var active = !!((_this$selectedCard2 = this.selectedCard) !== null && _this$selectedCard2 !== void 0 && _this$selectedCard2.nft);
      btn.disabled = !active;
      btn.classList.toggle('is-active', active);
    }
  }, {
    key: "bindSendEvents",
    value: function bindSendEvents() {
      var _root$querySelector,
        _root$querySelector3,
        _this5 = this,
        _root$querySelector4;
      var root = document.querySelector('.rs-publish-nft-send');
      if (!root) {
        return;
      }
      var errorEl = root.querySelector('.rs-publish-error');
      var showError = function showError(msg) {
        if (!errorEl) {
          return;
        }
        errorEl.textContent = msg;
        errorEl.hidden = !msg;
      };
      (_root$querySelector = root.querySelector('[data-action="publish-copy-hash"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _root$querySelector2;
        var hash, _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              hash = (_root$querySelector2 = root.querySelector('.rs-publish-address')) === null || _root$querySelector2 === void 0 ? void 0 : _root$querySelector2.value;
              if (hash) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              _context7.p = 1;
              _context7.n = 2;
              return navigator.clipboard.writeText(hash);
            case 2:
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t3 = _context7.v;
            case 4:
              return _context7.a(2);
          }
        }, _callee4, null, [[1, 3]]);
      })));
      (_root$querySelector3 = root.querySelector('[data-action="publish-nft-max"]')) === null || _root$querySelector3 === void 0 || _root$querySelector3.addEventListener('click', function () {
        var _this5$selectedCard;
        var nft = (_this5$selectedCard = _this5.selectedCard) === null || _this5$selectedCard === void 0 ? void 0 : _this5$selectedCard.nft;
        var amountInput = root.querySelector('.rs-publish-nft-amount');
        if (!nft || !amountInput) {
          return;
        }
        amountInput.value = String(nft.getTotalAmount() || 0);
      });
      (_root$querySelector4 = root.querySelector('[data-action="publish-nft-broadcast"]')) === null || _root$querySelector4 === void 0 || _root$querySelector4.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this5$selectedCard2, _root$querySelector5, _root$querySelector6;
        var nft, nftAmountRaw, feeRaw, nftAmount, fee, totalAvailable, btn, _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              showError('');
              nft = (_this5$selectedCard2 = _this5.selectedCard) === null || _this5$selectedCard2 === void 0 ? void 0 : _this5$selectedCard2.nft;
              if (nft) {
                _context8.n = 1;
                break;
              }
              showError('Select an NFT to publish.');
              return _context8.a(2);
            case 1:
              nftAmountRaw = (_root$querySelector5 = root.querySelector('.rs-publish-nft-amount')) === null || _root$querySelector5 === void 0 ? void 0 : _root$querySelector5.value;
              feeRaw = (_root$querySelector6 = root.querySelector('.rs-publish-fee')) === null || _root$querySelector6 === void 0 ? void 0 : _root$querySelector6.value;
              nftAmount = parseNftAmount(nftAmountRaw);
              fee = parseSaitoAmount(feeRaw, true);
              if (nftAmount) {
                _context8.n = 2;
                break;
              }
              showError('Enter a valid NFT amount.');
              return _context8.a(2);
            case 2:
              if (!(fee === null)) {
                _context8.n = 3;
                break;
              }
              showError('Enter a valid fee.');
              return _context8.a(2);
            case 3:
              totalAvailable = nft.getTotalAmount ? nft.getTotalAmount() : 0;
              if (!(nftAmount > totalAvailable)) {
                _context8.n = 4;
                break;
              }
              showError("Insufficient NFT units (".concat(totalAvailable, " available)."));
              return _context8.a(2);
            case 4:
              btn = root.querySelector('[data-action="publish-nft-broadcast"]');
              if (btn) {
                btn.disabled = true;
                btn.textContent = 'Publishing…';
              }
              _context8.p = 5;
              _context8.n = 6;
              return _this5.broadcastPublishNft(nft, nftAmount, fee || '0', {
                callback: function callback(result) {
                  if ((result === null || result === void 0 ? void 0 : result.status) === 'confirmed') {
                    var _this5$mainUi, _this5$mainUi$openPos;
                    (_this5$mainUi = _this5.mainUi) === null || _this5$mainUi === void 0 || (_this5$mainUi$openPos = _this5$mainUi.openPostPublish) === null || _this5$mainUi$openPos === void 0 || _this5$mainUi$openPos.call(_this5$mainUi, {
                      tx: result.tx || _this5.lastPublishedTx,
                      p2shAddress: _this5.p2shAddress,
                      p2shHash: _this5.p2shHash,
                      blockId: result.blockId,
                      txOrdinal: result.txOrdinal,
                      blk: result.blk
                    });
                  }
                }
              });
            case 6:
              _this5.publishFlow.lastPublishedTx = _this5.lastPublishedTx;
              _this5.publishFlow.p2shAddress = _this5.p2shAddress;
              _this5.publishFlow.p2shHash = _this5.p2shHash;
              _this5.hide();
              _context8.n = 8;
              break;
            case 7:
              _context8.p = 7;
              _t4 = _context8.v;
              showError((_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || 'Could not publish the transaction.');
              if (btn) {
                btn.disabled = false;
                btn.textContent = 'Publish';
                _this5.syncPublishButtonState();
              }
            case 8:
              return _context8.a(2);
          }
        }, _callee5, null, [[5, 7]]);
      })));
    }
  }, {
    key: "broadcastPublishNft",
    value: function () {
      var _broadcastPublishNft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(nft, nftAmount, feeSaito) {
        var _ref3,
          _ref3$callback,
          callback,
          locking,
          hash,
          address,
          newtx,
          _args9 = arguments,
          _t5;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _ref3 = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {}, _ref3$callback = _ref3.callback, callback = _ref3$callback === void 0 ? null : _ref3$callback;
              locking = lockingView(this.mod.getScript());
              hash = this.app.core.scripting.hash(locking);
              address = this.app.core.scripting.address(locking);
              if (!(!hash || !address)) {
                _context9.n = 1;
                break;
              }
              throw new Error('Could not derive script address');
            case 1:
              this.p2shAddress = address;
              this.p2shHash = hash;
              _context9.n = 2;
              return this.mod.broadcastPublish({
                assetType: 'nft',
                locking: locking,
                p2shAddress: address,
                p2shHash: hash,
                feeSaito: feeSaito,
                nft: nft,
                nftAmount: nftAmount,
                callback: callback
              });
            case 2:
              newtx = _context9.v;
              this.lastPublishedTx = newtx;
              _context9.p = 3;
              _context9.n = 4;
              return this.app.wallet.updateNFTList();
            case 4:
              _context9.n = 6;
              break;
            case 5:
              _context9.p = 5;
              _t5 = _context9.v;
              console.warn('publish NFT: updateNFTList', _t5);
            case 6:
              return _context9.a(2, newtx);
          }
        }, _callee6, this, [[3, 5]]);
      }));
      function broadcastPublishNft(_x, _x2, _x3) {
        return _broadcastPublishNft.apply(this, arguments);
      }
      return broadcastPublishNft;
    }()
  }]);
}();
module.exports = PublishNFTFlow;